<template>

    <transition name="modal">

        <div class="modal-mask" id="MobileMenu">

            <div class="modal-wrapper">

                <div class="modal-content">

                    <button type="button" class="close" aria-label="Close" @click="close">

                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26.16 26.16">
                            <g>
                                <g>
                                    <rect x="-4.92" y="12.58" width="36" height="2"
                                        transform="translate(13.08 -5.42) rotate(45)" style="fill: #fff" />
                                    <rect x="-4.92" y="12.58" width="36" height="2"
                                        transform="translate(-5.42 13.08) rotate(-45)" style="fill: #fff" />
                                </g>
                            </g>
                        </svg>

                    </button>

                    <div class="modal-body">

                        <a :href="homeRoute" class="menu-logo mb-2 nav-center-image">

                            <picture>
                                <source :srcset="headerLogo + '.webp'" type="image/webp">
                                <source :srcset="headerLogo + '.png'" type="image/png">
                                <img :src="headerLogo + '.png'" alt="GAME OF THRONES: CONQUEST"
                                    class="nav-center-social">
                            </picture>

                        </a>

                        <ul class="links">
                            <li class="nav-item">
                                <a class="nav-link" :href="homeRoute"><img class="mobile-nav-image"
                                        src="https://images.ctfassets.net/nwksj2ft7iku/3FaiwdJB6XN7XHVYj0yD4K/6e8f17c48134c66aa4957d0cfb85a36e/Home.png"></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :href="newsRoute"><img class="mobile-nav-image"
                                        src="https://images.ctfassets.net/nwksj2ft7iku/6ArQrY7wqtye2Zh56jrNEx/9ba1dfa2b69a64382aa18f1da37ec755/LatestNews.png"></a>
                            </li>

                        </ul>

                        <div class="stores">

                            <a style="opacity: 0" :class="{'show':showIOS}" v-show="showIOS"
                                href="https://apps.apple.com/us/app/game-of-thrones-conquest/id1035712810" target="_blank">

                                <img :src="iosLogo" alt="" class="app-store img-fluid nav-center-platform">

                            </a>

                            <a style="opacity: 0" :class="{'show':showAndroid}" v-show="showAndroid"
                                href="https://play.google.com/store/apps/details?id=com.wb.goog.got.conquest" target="_blank">

                                <img :src="androidLogo" alt="" class="android img-fluid nav-center-platform">

                            </a>

                        </div>


                        <div class="nav-center-social">

                            <div class="social mt-2">

                                <a class="social-list" :href="facebook" title="Facebook" target="_blank" rel="noopener"
                                    aria-label="Visit Facebook.com" data-toggle="tooltip" data-placement="bottom">
                                    <font-awesome-icon :icon="['fab', 'facebook']" fixed-width></font-awesome-icon>

                                </a>

                                <a class="social-list" :href="twitter" title="X" target="_blank" rel="noopener"
                                    aria-label="Visit X.com" data-toggle="tooltip" data-placement="bottom">
                                    <font-awesome-icon :icon="['fab', 'x-twitter']" fixed-width></font-awesome-icon>

                                </a>

                                <a class="social-end" :href="discord" title="discord" target="_blank" rel="noopener"
                                    aria-label="Visit Discord.com" data-toggle="tooltip" data-placement="bottom">
                                    <font-awesome-icon :icon="['fab', 'discord']" fixed-width></font-awesome-icon>

                                </a>
                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>

    </transition>

</template>

<script>

    import { mapState, mapMutations } from 'vuex';

    export default {
        name: "mobile-nav-panel",

        props:[
            'homeRoute',
            'newsRoute',
            'headerLogo',
            'facebook',
            'twitter',
            'discord',
            'iosLogo',
            'androidLogo',

        ],

        components: {

        },

        data(){
            return {
	            currentRoute:'/',
                xDown: null,
                yDown: null,
                gameInfoExpanded:false,
                socialExpanded:false,

            }
        },

        mounted(){
            // this.$el.addEventListener('touchstart', this.handleTouchStart, false);
            //this.$el.addEventListener('touchmove', this.handleTouchMove, false);
	        this.currentRoute = window.location.pathname;


            document.addEventListener("keydown", (e) => {
                //console.log('key',this.show);
                if (e.keyCode == 27) {

                    this.$emit('close');
                }
            });

            //console.log('Component mounted.', this.locale);

            /*axios.get( '/services/locales/' + this.locale )
                .then( response => {

                    this.locales = response.data;

                })
                .catch(error => {

                   // console.log('error.response', error );

                    //this.errors = error.response.data

                });*/


        },

        methods: {

            ...mapMutations([]),

            close(){

                if( this.showLanguageDrawer ){
                    this.showLanguageDrawer = false;
                }else{
                    //this.$emit('close');
                    this.$store.commit('storeShowMobileMenu',false);
                }

            },

            getTouches(evt) {
                return evt.touches ||             // browser API
                    evt.originalEvent.touches; // jQuery
            },

            handleTouchStart(evt) {
                const firstTouch = this.getTouches(evt)[0];
                this.xDown = firstTouch.clientX;
                this.yDown = firstTouch.clientY;
            },

            handleTouchMove(evt) {
                if ( ! this.xDown || ! this.yDown ) {
                    return;
                }

                let xUp = evt.touches[0].clientX;
                let yUp = evt.touches[0].clientY;

                let xDiff = this.xDown - xUp;
                let yDiff = this.yDown - yUp;

                if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
                    if ( xDiff > 0 ) {
                        /* left swipe */
                    } else {
                        /* right swipe */
                    }
                } else {
                    if ( yDiff > 0 ) {
                        /* up swipe */
                    } else {
                        /* down swipe */

                        if(!this.showLanguageDrawer){
                            //console.log('swiped down!',this.showLanguageDrawer);
                            //this.$emit('close');
                            this.close();
                        }else{
                            this.showLanguageDrawer = false;
                        }

                    }
                }
                /* reset values */
                this.xDown = null;
                this.yDown = null;
            },




        },

        computed: {

            ...mapState(['isMobile','showIOS','showAndroid']),




        },

    }
</script>

<style scoped>

</style>
